import { AnalysisBoard } from "@/features/analyze/components/analysis-board";
import { useEngine } from "@/hooks/use-engine";
import { getPageSummary, PAGE } from "@/pages";
import { toIsoDateString } from "@banjoanton/utils";
import { ChessGameRepository } from "@chesspresso/chess/src/db/chess-game-repository";
import { createLogger } from "@chesspresso/common";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useLiveQuery } from "dexie-react-hooks";
import z from "zod/v4";

const logger = createLogger("analyze-slug");

const searchSchema = z.object({
    positionIndex: z.number().optional(),
});

export const Route = createFileRoute("/(container)/analyze/$slug")({
    component: RouteComponent,
    validateSearch: zodValidator(searchSchema),
    loader: async ({ params }) => {
        const game = await ChessGameRepository.getBySlug(params.slug);

        if (!game) {
            logger.error({ slug: params.slug }, "Game not found for slug");
            throw redirect({ to: "/analyze" });
        }

        return {
            game,
            slug: params.slug,
        };
    },
});

// const page = getPageSummary(PAGE.Analyze);

function RouteComponent() {
    const { slug } = Route.useLoaderData();
    const { positionIndex } = Route.useSearch();

    // load with live query to get latest moves when they are analyzed
    const game = useLiveQuery(() => ChessGameRepository.getBySlug(slug));
    const engineHook = useEngine();

    if (!game) {
        return null;
    }

    console.log({ game });
    // const desc = `${game.white.username} vs ${game.black.username}, ${toIsoDateString(new Date(game.endTimeUnix * 1000))}`;
    return (
        <AnalysisBoard
            engineHook={engineHook}
            game={game}
            positionIndex={positionIndex}
        />
    );
}
